export default __webpack_public_path__ + "static/media/fuse_white_logo.a79cf9a0.svg";